import { Benutzer, BenutzerRolle } from '@/models/BenutzerModels';

export type State = {
  benutzer: Array<Benutzer>;
  benutzerrollen: Array<BenutzerRolle>;
};

export const state: State = {
  benutzer: sessionStorage.getItem('benutzer') != null ? JSON.parse(sessionStorage.benutzer) : new Array<Benutzer>(),
  benutzerrollen: sessionStorage.getItem('benutzerrollen') != null ? JSON.parse(sessionStorage.benutzerrollen) : new Array<BenutzerRolle>(),
};
